import { MdKeyboardArrowRight, MdArrowForward } from 'react-icons/md';
import { motion } from "framer-motion";
import { MdOutlineAnalytics, MdOutlineArticle, MdOutlineShare } from "react-icons/md";
import { useNavigate } from "react-router-dom"; // correct

export function renderGettingStarted() {
  return <GettingStartedComponent />;
}

export function GettingStartedComponent () {
    const navigate = useNavigate();

    const featureItems = [
      { title: "Metrics", color: "blue", icon: MdOutlineAnalytics },
      { title: "Traces", color: "red", icon: MdOutlineAnalytics },
      { title: "Logs", color: "green", icon: MdOutlineArticle },
      { title: "Topology", color: "purple", icon: MdOutlineShare },
    ];
    
    const featureStyles = {
      blue: {
        chip: "bg-blue-50 text-blue-700 dark:bg-blue-900/25 dark:text-blue-300",
        icon: "text-blue-600 dark:text-blue-400",
      },
      red: {
        chip: "bg-red-50 text-red-700 dark:bg-red-900/25 dark:text-red-300",
        icon: "text-red-600 dark:text-red-400",
      },
      green: {
        chip: "bg-green-50 text-green-700 dark:bg-green-900/25 dark:text-green-300",
        icon: "text-green-600 dark:text-green-400",
      },
      purple: {
        chip: "bg-purple-50 text-purple-700 dark:bg-purple-900/25 dark:text-purple-300",
        icon: "text-purple-600 dark:text-purple-400",
      },
    };
    return (
      <div className="transition-opacity duration-300">
        {/* Header */}
        <motion.section
          id="introduction"
          className="border-b border-gray-200 dark:border-gray-800 pb-8 mb-10 scroll-mt-24"
          initial={{ opacity: 0, y: 22 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.35 }}
          transition={{ duration: 0.6, ease: "easeOut" }}
        >
          <div className="inline-flex items-center px-3 py-1 rounded-full bg-orange-100 dark:bg-orange-900/30 text-orange-600 dark:text-orange-400 text-xs font-bold uppercase tracking-wider mb-4 border border-orange-200 dark:border-orange-800 shadow-sm">
            Guide
          </div>
    
          <div className="flex flex-col lg:flex-row lg:items-center gap-5 mb-6">
  
          <h1 className="text-3xl lg:text-5xl font-extrabold text-text-main dark:text-white tracking-tight leading-tight">
              <span className="bg-clip-text text-transparent bg-gradient-to-r from-orange-500 to-red-600">
                Getting Started
              </span>
              <br />
              with Netraa APM
            </h1>

  {/* BUTTON GROUP */}
  <div className="flex items-center gap-3 ml-auto">
    <motion.button
      onClick={() => navigate("/quickStart", { state: { from: window.location.pathname } })}
      className="px-6 py-4 bg-gradient-to-r from-orange-600 to-red-600 text-white rounded-xl font-bold whitespace-nowrap"
    >
      Quick Start
    </motion.button>

    {/* <motion.button
      onClick={() => navigate("/demo", { state: { from: window.location.pathname } })}
      className="px-6 py-4 bg-gradient-to-r from-orange-600 to-red-600 text-white rounded-xl font-bold whitespace-nowrap"
    >
      View Demo
    </motion.button> */}
  </div>

</div>
    
          <p className="text-xl text-text-muted dark:text-gray-400 leading-relaxed mb-4">
            Unified Full-Stack Observability for Modern Distributed Applications. Monitor every trace, log, and metric across your entire infrastructure in a single pane of glass.
          </p>
    
          <p className="text-base text-text-muted dark:text-gray-500 leading-relaxed">
            This guide will help you understand the core capabilities of Netraa APM and how it provides real-time, actionable insights to monitor and optimize your applications immediately after deployment.
          </p>
        </motion.section>
    
        {/* Introduction Section */}
        <motion.section
      id="introduction"
      className="border-b border-gray-200 dark:border-gray-800 pb-8 mb-10 scroll-mt-24"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 0.5, ease: "easeOut" }}
    >                                                                 
          <h2 className="text-2xl font-bold text-text-main dark:text-white mb-6">
            Introduction to Netraa APM
          </h2>
    
          <div className="mb-12">
            <h3 className="text-xl font-bold text-text-main dark:text-white mb-4">
              What is Netraa APM?
            </h3>
    
            <p className="text-lg text-text-muted dark:text-gray-300 mb-8 leading-relaxed">
              Netraa APM is a unified observability platform that delivers deep application performance monitoring alongside infrastructure and database visibility. It automatically correlates traces, logs, and metrics to provide contextual insights into distributed system behavior, enabling faster root cause analysis across microservices and cloud-native architectures.
            </p>
    
            {/* Animated Highlight Cards */}
            <div className="grid grid-cols-1 lg:grid-cols-[1fr_1.25fr_0.85fr] gap-8 mb-12 items-center">
              <div className="flex flex-col gap-4 w-full">
                {featureItems.map((item, i) => {
                  const Icon = item.icon;
                  const s = featureStyles[item.color];
    
                  return (
                    <motion.div
                      key={item.title}
                      initial={{ opacity: 0, x: -16 }}
                      whileInView={{ opacity: 1, x: 0 }}
                      viewport={{ once: true, amount: 0.3 }}
                      transition={{ duration: 0.45, delay: i * 0.08 }}
                      whileHover={{ y: -2 }}
                      className="group flex items-center gap-3 p-3 rounded-xl border border-gray-200 dark:border-gray-700
                                 bg-white/90 dark:bg-[#202020]/90 backdrop-blur-sm shadow-sm
                                 transition-all duration-300 hover:shadow-md hover:border-gray-300 dark:hover:border-gray-600"
                    >
                      <div className={`p-2 rounded-lg ${s.chip} transition-transform duration-300 group-hover:scale-105`}>
                        <Icon className={`text-sm ${s.icon}`} />
                      </div>
                      <span className="text-sm font-bold text-text-main dark:text-white">
                        {item.title}
                      </span>
                    </motion.div>
                  );
                })}
              </div>
    
              {/* Animated Central Circle */}
              <div className="flex items-center justify-center relative w-full py-8">
                <div className="absolute inset-0 hidden md:flex items-center justify-center pointer-events-none opacity-25">
                  <svg className="w-full h-full" viewBox="0 0 200 200">
                    <path d="M 0 30 Q 100 30 100 100" fill="none" stroke="currentColor" strokeDasharray="4" strokeWidth="2" />
                    <path d="M 0 75 Q 50 75 100 100" fill="none" stroke="currentColor" strokeDasharray="4" strokeWidth="2" />
                    <path d="M 0 125 Q 50 125 100 100" fill="none" stroke="currentColor" strokeDasharray="4" strokeWidth="2" />
                    <path d="M 0 170 Q 100 170 100 100" fill="none" stroke="currentColor" strokeDasharray="4" strokeWidth="2" />
                  </svg>
                </div>
    
                <motion.div
                  initial={{ scale: 0.92, opacity: 0 }}
                  whileInView={{ scale: 1, opacity: 1 }}
                  viewport={{ once: true, amount: 0.4 }}
                  transition={{ duration: 0.6, ease: "easeOut" }}
                  whileHover={{ scale: 1.03 }}
                  className="relative z-10 w-40 h-40 rounded-full bg-white dark:bg-[#1a1a1a] border-4 border-orange-500/15 flex items-center justify-center
                             shadow-[0_0_40px_rgba(255,87,34,0.18)] dark:shadow-[0_0_45px_rgba(255,87,34,0.12)]"
                >
                  <motion.div
                    className="absolute inset-0 rounded-full bg-orange-500/10"
                    animate={{ scale: [1, 1.08, 1], opacity: [0.18, 0.08, 0.18] }}
                    transition={{ duration: 2.6, repeat: Infinity, ease: "easeInOut" }}
                  />
    
                  <div className="w-32 h-32 rounded-full bg-gradient-to-r from-orange-500 to-red-600 flex flex-col items-center justify-center shadow-inner text-white p-4 text-center relative z-10">
                    <span className="material-symbols-outlined text-4xl mb-1">
                      psychology
                    </span>
                    <span className="text-[10px] font-bold uppercase tracking-wider leading-tight">
                      Netraa<br />Intelligence
                    </span>
                  </div>
                </motion.div>
              </div>
    
              {/* Actionable Insights Box */}
              <div className="flex justify-center md:justify-start w-full">
                <motion.div
                  initial={{ opacity: 0, x: 16 }}
                  whileInView={{ opacity: 1, x: 0 }}
                  viewport={{ once: true, amount: 0.3 }}
                  transition={{ duration: 0.45, delay: 0.12 }}
                  whileHover={{ y: -3 }}
                  className="bg-surface-light dark:bg-[#202020] p-4 rounded-2xl border border-border-color dark:border-gray-700 shadow-sm w-36 h-36 mt-10 backdrop-blur-sm transition-all duration-300 hover:shadow-md hover:border-gray-300 dark:hover:border-gray-600"
                >
                  <div className="flex items-center gap-2 mb-3 border-b border-gray-100 dark:border-gray-700 pb-2">
                    <span className="w-2 h-2 rounded-full bg-green-500"></span>
                    <span className="text-xs font-bold text-text-muted">
                      Actionable Insights
                    </span>
                  </div>
                  <div className="space-y-2">
                    <div className="h-3 w-3/4 bg-gray-100 dark:bg-white/10 rounded-full"></div>
                    <div className="h-3 w-full bg-gray-100 dark:bg-white/10 rounded-full"></div>
                    <div className="h-3 w-5/6 bg-gray-100 dark:bg-white/10 rounded-full"></div>
                  </div>
                </motion.div>
              </div>
            </div>
          </div>
    
          {/* Problems Solved */}
          <div id="problems-solved" className="mb-16 scroll-mt-24">
            <h3 className="text-xl font-bold text-text-main dark:text-white mb-6">
              Problems Netraa APM Solves
            </h3>
    
            <div className="grid md:grid-cols-2 gap-8">
              {/* BEFORE */}
              <motion.div
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, amount: 0.25 }}
                transition={{ duration: 0.45 }}
                whileHover={{ y: -4 }}
                className="rounded-2xl border border-gray-200 dark:border-gray-800 p-7 bg-white dark:bg-[#1A1C20] flex flex-col shadow-sm transition-all duration-300 hover:shadow-xl hover:border-gray-300 dark:hover:border-gray-700"
              >
                <div>
                  <div className="flex justify-between items-center mb-2">
                    <h4 className="text-lg font-bold">The "Silo" Problem</h4>
                    <span className="px-2 py-1 text-[10px] font-bold bg-red-100 text-red-600 rounded border border-red-200">
                      BEFORE
                    </span>
                  </div>
    
                  <p className="text-sm text-gray-500">
                    Centralizes telemetry streams from applications, infrastructure, databases, and integrated external sources into a correlated observability layer.
                  </p>
                </div>
    
                <div className="flex flex-col items-center mt-4">
                  <div className="flex items-center mt-12 gap-6 opacity-40">
                    <div className="w-20 h-28 rounded-xl border border-gray-400 dark:border-gray-800 flex flex-col items-center justify-center text-xs bg-white/80 dark:bg-[#181818]">
                      <span className="material-symbols-outlined text-3xl mb-2">
                        monitoring
                      </span>
                      Tool A
                      <span className="text-[10px]">(Metrics)</span>
                    </div>
    
                    <div className="w-10 h-[2px] bg-red-300"></div>
    
                    <div className="w-20 h-28 rounded-xl border border-gray-400 dark:border-gray-800 flex flex-col items-center justify-center text-xs bg-white/80 dark:bg-[#181818]">
                      <span className="material-symbols-outlined text-3xl mb-2">
                        description
                      </span>
                      Tool B
                      <span className="text-[10px]">(Logs)</span>
                    </div>
                  </div>
    
                  <div className="text-red-500 flex items-center gap-2 text-sm mt-16">
                    <span className="material-symbols-outlined text-base">warning</span>
                    Disconnected & Fragmented Data
                  </div>
                </div>
              </motion.div>
    
              {/* AFTER */}
              <motion.div
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, amount: 0.25 }}
                transition={{ duration: 0.55, delay: 0.05 }}
                whileHover={{ y: -4 }}
                className="rounded-2xl border border-gray-200 dark:border-gray-500/20 p-7 relative bg-white dark:bg-[#1A1C20] flex flex-col justify-between shadow-sm transition-all duration-300 hover:shadow-xl hover:border-gray-300 dark:hover:border-gray-700"
              >
                <div>
                  <div className="flex justify-between items-center mb-2">
                    <h4 className="text-lg font-bold">Netraa Unified Observability</h4>
                    <span className="px-2 py-1 text-[10px] font-bold bg-green-100 text-green-600 rounded border border-green-200">
                      AFTER
                    </span>
                  </div>
    
                  <p className="text-sm text-gray-500 mb-8">
                    Normalizes fragmented data across tools, providing correlated context for instant root cause analysis (RCA).
                  </p>
                </div>
    
                <div className="flex flex-col items-center gap-6">
                  <motion.div
                    whileHover={{ scale: 1.02 }}
                    className="bg-white dark:bg-[#141414] border border-gray-200 dark:border-gray-800 rounded-2xl px-6 py-5 flex flex-col gap-4 shadow-sm relative overflow-hidden"
                  >
                    <div className="absolute inset-0 bg-gradient-to-b from-orange-500/5 to-transparent pointer-events-none" />
    
                    <div className="flex items-center gap-4 relative z-10">
                      <motion.div
                        animate={{ scale: [1, 1.06, 1] }}
                        transition={{ duration: 2.2, repeat: Infinity, ease: "easeInOut" }}
                        className="w-10 h-10 rounded-lg bg-orange-500 flex items-center justify-center"
                      >
                        <span className="material-symbols-outlined text-white">hub</span>
                      </motion.div>
    
                      <div>
                        <div className="font-semibold text-sm">Netraa Unified View</div>
                        <div className="text-[10px] text-orange-500 font-bold">
                          CORRELATED STREAM
                        </div>
                      </div>
                    </div>
    
                    <div className="flex gap-4 mt-2 relative z-10">
                      <div className="bg-gray-100 dark:bg-[#1f1610] border border-gray-200 dark:border-gray-800 px-3 py-1 rounded text-[10px] font-mono text-gray-700 dark:text-gray-300">
                        metric_id: a19f
                      </div>
                      <div className="bg-gray-100 dark:bg-[#1f1610] border border-gray-200 dark:border-gray-800 px-3 py-1 rounded text-[10px] font-mono text-gray-700 dark:text-gray-300">
                        trace_id: 820z
                      </div>
                    </div>
    
                    <div className="flex gap-4 mt-2 relative z-10">
                      <div className="bg-gray-100 dark:bg-[#1f1610] border border-gray-200 dark:border-gray-800 px-3 py-1 rounded text-[10px] font-mono text-gray-700 dark:text-gray-300">
                        log_ref: 99x
                      </div>
                      <div className="bg-gray-100 dark:bg-[#1f1610] border border-gray-200 dark:border-gray-800 px-3 py-1 rounded text-[10px] font-mono text-gray-700 dark:text-gray-300">
                        node: k8s_worker
                      </div>
                    </div>
                  </motion.div>
    
                  <div className="text-green-600 flex items-center gap-2 text-sm">
                    <span className="material-symbols-outlined text-base">
                      check_circle
                    </span>
                    Automated Correlation
                  </div>
                </div>
              </motion.div>
            </div>
          </div>
    
          {/* Key Differentiators */}
          <div id="key-differentiators" className="mb-12 scroll-mt-24">
            <h3 className="text-xl font-bold text-text-main dark:text-white mb-6">
              Key Differentiators of Netraa APM
            </h3>
    
            <div className="px-2 md:px-3 overflow-visible">
              <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
                {[
                  {
                    title: "Code-level Insight",
                    desc: "No-code instrumentation with deep profiling for Java, Go, Python, and Node.js applications.",
                    icon: "analytics",
                    color: "orange",
                  },
                  {
                    title: "Infra/K8s Visibility",
                    desc: "Native Kubernetes monitoring with cluster-level visibility, node health tracking, and container performance insights.",
                    icon: "analytics",
                    color: "blue",
                  },
                  {
                    title: "Enterprise Security",
                    desc: "RBAC, SSO integration, and data masking out of the box to meet compliance standards.",
                    icon: "analytics",
                    color: "green",
                  },
                ].map((item, idx) => {
                  const colorStyles = {
                    orange: {
                      bg: "bg-orange-100 dark:bg-orange-900/30",
                      text: "text-orange-500",
                      glow: "bg-orange-400/10 dark:bg-orange-500/10",
                      border:
                        "group-hover:border-orange-300/50 dark:group-hover:border-orange-500/40",
                    },
                    blue: {
                      bg: "bg-blue-100 dark:bg-blue-900/30",
                      text: "text-blue-500",
                      glow: "bg-blue-400/10 dark:bg-blue-500/10",
                      border:
                        "group-hover:border-blue-300/50 dark:group-hover:border-blue-500/40",
                    },
                    green: {
                      bg: "bg-green-100 dark:bg-green-900/30",
                      text: "text-green-500",
                      glow: "bg-green-400/10 dark:bg-green-500/10",
                      border:
                        "group-hover:border-green-300/50 dark:group-hover:border-green-500/40",
                    },
                  };
    
                  const styles = colorStyles[item.color];
    
                  return (
                    <motion.div
                      key={idx}
                      initial={{ opacity: 0, y: 18 }}
                      whileInView={{ opacity: 1, y: 0 }}
                      viewport={{ once: true, amount: 0.25 }}
                      transition={{ duration: 0.45, delay: idx * 0.08 }}
                      whileHover={{ y: -4, scale: 1.015 }}
                      className="
                        group relative flex flex-col gap-4 p-6 rounded-2xl
                        bg-surface-light dark:bg-[#1A1C20]
                        border border-border-color dark:border-border-dark
                        shadow-sm
                        transition-all duration-300 ease-out
                        hover:shadow-xl dark:hover:shadow-black/40
                      "
                    >
                      <div
                        className={`
                          absolute inset-0 rounded-2xl opacity-0 group-hover:opacity-100
                          transition duration-300 blur-2xl ${styles.glow}
                        `}
                      />
    
                      <div
                        className={`
                          relative z-10 w-12 h-12 shrink-0 rounded-xl
                          flex items-center justify-center ${styles.bg}
                          transition-all duration-300
                          group-hover:scale-110 group-hover:rotate-3
                        `}
                      >
                        <span className={`material-symbols-outlined text-2xl ${styles.text}`}>
                          {item.icon}
                        </span>
                      </div>
    
                      <div className="relative z-10">
                        <h4 className="font-bold text-lg mb-2 text-text-main dark:text-white">
                          {item.title}
                        </h4>
                        <p className="text-sm text-text-muted leading-relaxed">
                          {item.desc}
                        </p>
                      </div>
    
                      <div
                        className={`
                          pointer-events-none absolute inset-0 rounded-2xl border border-transparent
                          transition duration-300 ${styles.border}
                        `}
                      />
                    </motion.div>
                  );
                })}
              </div>
            </div>
          </div>
    
          {/* Workflow Integration */}
          <motion.div
            id="workflow-integration"
            className="mb-16 scroll-mt-24"
            initial={{ opacity: 0, y: 18 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, amount: 0.25 }}
            transition={{ duration: 0.5 }}
          >
            <h3 className="text-xl font-bold text-text-main dark:text-white mb-4">
              Where Netraa APM Fits in DevOps and SRE Workflows
            </h3>
            <p className="text-base text-text-muted dark:text-gray-400 leading-relaxed mb-6">
              Netraa APM integrates into DevOps and SRE workflows by enabling real-time deployment validation, SLO monitoring, incident investigation through distributed traces, and performance regression analysis after releases.
            </p>
            <div className="p-6 bg-gray-50 dark:bg-[#181818] rounded-2xl border border-gray-200 dark:border-gray-800 shadow-sm">
              <div className="flex flex-col lg:flex-row items-center justify-between gap-4">
                <div className="flex flex-col sm:flex-row items-center gap-3 sm:gap-2">
                  <div className="px-3 py-1.5 rounded-lg bg-white dark:bg-gray-800 border border-gray-200 dark:border-gray-700 text-xs font-mono shadow-sm">
                    CI/CD Pipeline
                  </div>
                  <MdKeyboardArrowRight className="text-gray-400 text-2xl hidden sm:block" />
                  <MdKeyboardArrowRight className="text-gray-400 text-2xl sm:hidden rotate-90" />
                  <div className="px-3 py-1.5 rounded-lg bg-white dark:bg-gray-800 border border-gray-200 dark:border-gray-700 text-xs font-mono shadow-sm">
                    Netraa APM Analysis
                  </div>
                  <MdKeyboardArrowRight className="text-gray-400 text-2xl hidden sm:block" />
                  <MdKeyboardArrowRight className="text-gray-400 text-2xl sm:hidden rotate-90" />
                  <div className="px-3 py-1.5 rounded-lg bg-white dark:bg-gray-800 border border-gray-200 dark:border-gray-700 text-xs font-mono shadow-sm">
                    Alerting
                  </div>
                </div>
              </div>
            </div>
          </motion.div>
    
          {/* Target Users */}
          <div id="who-should-use" className="mb-20 scroll-mt-24">
            <h2 className="text-2xl font-semibold text-gray-900 dark:text-white mb-10">
              Who Should Use Netraa APM?
            </h2>
    
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
              {[
                {
                  title: "SRE Teams",
                  icon: "engineering",
                  desc: "Monitor SLOs, track error budgets, and perform fast root cause analysis using correlated telemetry data.",
                  color: "purple",
                },
                {
                  title: "DevOps Engineers",
                  icon: "terminal",
                  desc: "Automate CI/CD performance gates and monitor production deployments in real time.",
                  color: "blue",
                },
                {
                  title: "Application Architects",
                  icon: "architecture",
                  desc: "Visualize microservice topology and identify structural bottlenecks in distributed systems.",
                  color: "orange",
                },
                {
                  title: "Infrastructure & Ops Teams",
                  icon: "storage",
                  desc: "Map application performance to VM, container, and cloud resource constraints.",
                  color: "green",
                },
              ].map((user, idx) => {
                const colorMap = {
                  purple: "text-purple-600 dark:text-purple-400",
                  blue: "text-blue-600 dark:text-blue-400",
                  orange: "text-orange-600 dark:text-orange-400",
                  green: "text-green-600 dark:text-green-400",
                };
    
                return (
                  <motion.div
                    key={idx}
                    initial={{ opacity: 0, y: 18 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true, amount: 0.25 }}
                    transition={{ duration: 0.45, delay: idx * 0.08 }}
                    whileHover={{ y: -4 }}
                    className="group rounded-2xl border border-gray-200 dark:border-white/10
                               bg-white dark:bg-[#0F1115]
                               p-6 transition-all duration-300 ease-out
                               hover:border-gray-300 dark:hover:border-white/20
                               hover:shadow-lg dark:hover:shadow-black/30"
                  >
                    <div className="flex items-center gap-3 mb-4">
                      <span className={`material-symbols-outlined text-xl ${colorMap[user.color]}`}>
                        {user.icon}
                      </span>
    
                      <h4 className="text-lg font-semibold text-gray-900 dark:text-white">
                        {user.title}
                      </h4>
                    </div>
    
                    <p className="text-sm leading-relaxed text-gray-600 dark:text-gray-400">
                      {user.desc}
                    </p>
                  </motion.div>
                );
              })}
            </div>
          </div>
         {/* Promo Banner */}
          <motion.div
            id="promo-banner"
            className="relative overflow-hidden rounded-2xl mb-4 scroll-mt-24
                       bg-white dark:bg-[#0A0E1A]
                       border border-gray-200 dark:border-white/10
                       shadow-sm dark:shadow-[0_0_40px_rgba(139,92,246,0.08)]"
            initial={{ opacity: 0, y: 18 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, amount: 0.3 }}
            transition={{ duration: 0.5, ease: "easeOut" }}
          >
            {/* Left gradient accent bar */}
            <div className="absolute left-0 top-0 bottom-0 w-1.5 bg-gradient-to-b from-purple-500 via-fuchsia-500 to-cyan-400" />

            {/* Subtle glow, dark mode only */}
            <div className="pointer-events-none absolute -left-10 top-1/2 -translate-y-1/2 w-40 h-40 rounded-full bg-purple-500/20 blur-3xl hidden dark:block" />
            <div className="pointer-events-none absolute right-10 top-1/2 -translate-y-1/2 w-40 h-40 rounded-full bg-cyan-400/10 blur-3xl hidden dark:block" />

            <div className="relative z-10 flex flex-col lg:flex-row lg:items-center justify-between gap-6 px-8 py-8 pl-10">
              <div>
                <div className="text-xs font-bold uppercase tracking-wider text-cyan-600 dark:text-cyan-400 mb-3">
                  Ready to Unify Your Observability?
                </div>

                <h3 className="text-2xl lg:text-3xl font-extrabold text-text-main dark:text-white mb-3 leading-tight">
                  See Netraa in action.
                </h3>

                <p className="text-sm lg:text-base text-text-muted dark:text-gray-400 leading-relaxed max-w-md">
                  Discover how Netraa correlates metrics, traces, and logs to accelerate root cause analysis across your infrastructure.
                </p>
              </div>

              <motion.button
                whileHover={{ scale: 1.03 }}
                whileTap={{ scale: 0.98 }}
                onClick={() => (window.location.href = "https://cliqtest.com/book-a-demo")} 
                className="shrink-0 inline-flex items-center gap-2 px-6 py-3.5 rounded-xl font-bold text-sm
                           bg-gradient-to-r from-orange-600 to-red-600 text-white
                           shadow-sm hover:shadow-md transition-all duration-300
                           whitespace-nowrap"
              >
                Book a Demo
                <MdArrowForward className="text-lg" />
              </motion.button>
            </div>
          </motion.div>
        </motion.section>
      </div>
    );
}



// const renderGettingStarted = () => (
//   <div className="space-y-12 overflow-hidden" >
//     {/* Header */}
// <section
//   className="border-b border-gray-200 dark:border-gray-800 pb-8 mb-10 scroll-mt-24"
//   id="introduction"
// >
//   <div className="inline-flex items-center px-3 py-1 rounded-full bg-orange-100 dark:bg-orange-900/30 text-orange-600 dark:text-orange-400 text-xs font-bold uppercase tracking-wider mb-4 border border-orange-200 dark:border-orange-800">
//     Guide
//   </div>

//   {/* Title + Button Row */}
//   <div className="flex flex-col lg:flex-row lg:items-center lg:justify-between gap-4 mb-6">
//     <h1 className="text-3xl lg:text-5xl font-extrabold text-text-main dark:text-white tracking-tight">
//       <span className="bg-clip-text text-transparent bg-gradient-to-r from-orange-500 to-red-600">
//         Getting Started
//       </span>
//       <br />
//       with Netraa APM
//     </h1>

//     <button
//       onClick={() => // Example in SPA
// navigate("/demo", { state: { from: window.location.pathname } })}
//       className="px-6 py-4 bg-gradient-to-r from-orange-600 to-red-600 text-white rounded-lg font-bold shadow-lg shadow-orange-500/30 hover:shadow-orange-500/50 transform hover:-translate-y-1 transition-all whitespace-nowrap"
//     >
//       View Demo
//     </button>
//   </div>

//   <p className="text-xl text-text-muted dark:text-gray-400 max-w-4xl leading-relaxed mb-4">
//     Unified Full-Stack Observability for Modern Distributed Applications. Monitor every trace, log, and metric across your entire infrastructure in a single pane of glass.
//   </p>

//   <p className="text-base text-text-muted dark:text-gray-500 max-w-4xl leading-relaxed">
//     This guide will help you understand the core capabilities of Netraa APM and how it provides real-time, actionable insights to monitor and optimize your applications immediately after deployment.
//   </p>
// </section>

//     {/* Introduction Section */}
//     <section className="scroll-mt-24 mb-16">
//       <h2 className="text-2xl font-bold text-text-main dark:text-white mb-6">Introduction to Netraa APM</h2>
//       <div className="mb-12">
//         <h3 className="text-xl font-bold text-text-main dark:text-white mb-4">What is Netraa APM?</h3>
//         <p className="text-lg text-text-muted dark:text-gray-300 mb-8 max-w-3xl leading-relaxed">
//           Netraa APM is a unified observability platform that delivers deep application performance monitoring alongside infrastructure and database visibility. It automatically correlates traces, logs, and metrics to provide contextual insights into distributed system behavior, enabling faster root cause analysis across microservices and cloud-native architectures.        </p>

//       {/* Animated Highlight Cards */}
// <div className="relative grid grid-cols-1 md:grid-cols-3 gap-8 mb-12 max-w-4xl">
//   <div className="flex flex-col gap-6 w-full md:w-2/3">
//     {["Metrics", "Traces", "Logs", "Topology"].map((title, i) => {
//       // Determine colors dynamically
//       const colors = {
//         Metrics: "blue",
//         Traces: "red",
//         Logs: "green",
//         Topology: "purple",
//       };
//       const color = colors[title];

//       return (
//         <div
//           key={i}
//           className={`flex items-center gap-3 p-3 bg-white dark:bg-[#202020] rounded-lg border border-gray-200 dark:border-gray-700 shadow-sm`}
//         >
//           {/* Colored Icon */}
//           <div
//             className={`p-2 rounded text-${color}-600 bg-${color}-100 dark:bg-${color}-900/30 flex items-center justify-center`}
//           >
//             <span className="material-symbols-outlined text-sm">
//               {title === "Metrics"
//                 ? "."
//                 : title === "Traces"
//                 ? "timeline"
//                 : title === "Logs"
//                 ? "article"
//                 : "share"}
//             </span>
//           </div>

//           {/* Title Text */}
//           <span className="text-sm font-bold text-text-main dark:text-white">
//             {title}
//           </span>
//         </div>
//       );
//     })}
//   </div>


//         {/* Animated Central Circle */}
// <div className="flex flex-col items-center justify-center relative w-full md:w-2/3 py-8">
//   {/* Decorative SVG lines */}
//   <div className="absolute inset-0 hidden md:flex items-center justify-center pointer-events-none opacity-30">
//     <svg className="w-full h-full" viewBox="0 0 200 200">
//       <path d="M 0 30 Q 100 30 100 100" fill="none" stroke="currentColor" strokeDasharray="4" strokeWidth="2" />
//       <path d="M 0 75 Q 50 75 100 100" fill="none" stroke="currentColor" strokeDasharray="4" strokeWidth="2" />
//       <path d="M 0 125 Q 50 125 100 100" fill="none" stroke="currentColor" strokeDasharray="4" strokeWidth="2" />
//       <path d="M 0 170 Q 100 170 100 100" fill="none" stroke="currentColor" strokeDasharray="4" strokeWidth="2" />
//     </svg>
//   </div>

//   {/* Central Circle */}
//   <div className="relative z-10 w-40 h-40 rounded-full bg-white dark:bg-[#1a1a1a] border-4 border-netraa-orange-start/20 flex items-center justify-center shadow-[0_0_40px_rgba(255,87,34,0.2)]">
    
//     {/* Ping animation */}
//     <div className="absolute inset-0 rounded-full animate-ping opacity-10 bg-netraa-orange-end"></div>
    
//     {/* Inner gradient circle */}
// <div className="w-32 h-32 rounded-full bg-gradient-to-r from-orange-500 to-red-600 flex flex-col items-center justify-center shadow-inner text-black dark:text-white p-4 text-center">
//   <span className="material-symbols-outlined text-4xl mb-1">psychology</span>
//   <span className="text-[10px] font-bold uppercase tracking-wider leading-tight">
//     Netraa<br />Intelligence
//   </span>
// </div>

//   </div>
// </div>


//           {/* Actionable Insights Box */}
//           <div className="flex justify-center md:justify-start w-full md:w-1/3">
//   <div className="bg-surface-light dark:bg-[#202020] p-4 rounded-none border border-border-color dark:border-gray-700 shadow-sm w-32 h-32 mt-10">
//     <div className="flex items-center gap-2 mb-3 border-b border-gray-100 dark:border-gray-700 pb-2">
//       <span className="w-2 h-2 rounded-full bg-green-500"></span>
//       <span className="text-xs font-bold text-text-muted">Actionable Insights</span>
//     </div>
//     <div className="space-y-2">
//       <div className="h-3 w-3/4 bg-gray-100 dark:bg-white/10 rounded-none"></div>
//       <div className="h-3 w-full bg-gray-100 dark:bg-white/10 rounded-none"></div>
//       <div className="h-3 w-5/6 bg-gray-100 dark:bg-white/10 rounded-none"></div>
//     </div>
//   </div>
// </div>

//         </div>
//       </div>

//       {/* Problems Solved */}
//       <div id="problems-solved" className="mb-16 scroll-mt-24">
//   <h3 className="text-xl font-bold text-text-main dark:text-white mb-6">
//     Problems Netraa APM Solves
//   </h3>

// <div className="grid md:grid-cols-2 gap-8">

//   {/* BEFORE */}
//   <div className="rounded-xl border border-gray-200 dark:border-gray-800 p-7 bg-white dark:bg-[#1A1C20] flex flex-col">

//   {/* Top Section */}
//   <div>
//     <div className="flex justify-between items-center mb-2">
//       <h4 className="text-lg font-bold">The "Silo" Problem</h4>
//       <span className="px-2 py-1 text-[10px] font-bold bg-red-100 text-red-600 rounded border border-red-200">
//         BEFORE
//       </span>
//     </div>

//     <p className="text-sm text-gray-500">
//       Centralizes telemetry streams from applications, infrastructure, databases, and integrated external sources into a correlated observability layer.    </p>
//   </div>

// {/* Tools Section */}
// <div className="flex flex-col items-center mt-4">

//   <div className="flex items-center mt-12 gap-6 opacity-40">
//     {/* Tool A */}
//     <div className="w-20 h-28 rounded-xl border border-gray-400 dark:border-gray-800 flex flex-col items-center justify-center text-xs">
//       <span className="material-symbols-outlined text-3xl mb-2">
//         monitoring
//       </span>
//       Tool A
//       <span className="text-[10px]">(Metrics)</span>
//     </div>

//     {/* Connector */}
//     <div className="w-10 h-[2px] bg-red-300"></div>

//     {/* Tool B */}
//     <div className="w-20 h-28 rounded-xl border border-gray-400 dark:border-gray-800 flex flex-col items-center justify-center text-xs">
//       <span className="material-symbols-outlined text-3xl mb-2">
//         description
//       </span>
//       Tool B
//       <span className="text-[10px]">(Logs)</span>
//     </div>
//   </div>

//   {/* Warning / Disconnected */}
//   <div className="text-red-500 flex items-center gap-2 text-sm mt-16">
//     <span className="material-symbols-outlined text-base">warning</span>
//     Disconnected & Fragmented Data
//   </div>
//   </div>
// </div>


//   {/* AFTER */}
//   <div className="rounded-xl border border-gray-200 dark:border-gray-500/20 p-7 relative bg-white dark:bg-[#1A1C20] flex flex-col justify-between">
//     <div>
//       <div className="flex justify-between items-center mb-2">
//         <h4 className="text-lg font-bold">Netraa Unified Observability</h4>
//         <span className="px-2 py-1 text-[10px] font-bold bg-green-100 text-green-600 rounded border border-green-200">
//           AFTER
//         </span>
//       </div>

//       <p className="text-sm text-gray-500 mb-8">
//         Normalizes fragmented data across tools, providing correlated context for instant root cause analysis (RCA).
//       </p>
//     </div>

//     {/* unified card */}
//     <div className="flex flex-col items-center gap-6">

//       <div className="bg-white dark:bg-[#141414] border border-gray-200 dark:border-gray-800 rounded-xl px-6 py-5 flex flex-col gap-4 shadow-sm">

//         <div className="flex items-center gap-4">
//           <div className="w-10 h-10 rounded-lg bg-orange-500 flex items-center justify-center animate-pulse">
//             <span className="material-symbols-outlined text-white">hub</span>
//           </div>

//           <div>
//             <div className="font-semibold text-sm">Netraa Unified View</div>
//             <div className="text-[10px] text-orange-500 font-bold">
//               CORRELATED STREAM
//             </div>
//           </div>
//         </div>

//         {/* Metric & Trace IDs */}
//         <div className="flex gap-4 mt-2">
//           <div className="bg-gray-100 dark:bg-[#1f1610] border border-gray-200 dark:border-gray-800 px-3 py-1 rounded text-[10px] font-mono text-gray-700 dark:text-gray-300">
//             metric_id: a19f
//           </div>
//           <div className="bg-gray-100 dark:bg-[#1f1610] border border-gray-200 dark:border-gray-800 px-3 py-1 rounded text-[10px] font-mono text-gray-700 dark:text-gray-300">
//             trace_id: 820z
//           </div>
//         </div>

//         <div className="flex gap-4 mt-2">
//           <div className="bg-gray-100 dark:bg-[#1f1610] border border-gray-200 dark:border-gray-800 px-3 py-1 rounded text-[10px] font-mono text-gray-700 dark:text-gray-300">
//             log_ref: 99x
//           </div>
//           <div className="bg-gray-100 dark:bg-[#1f1610] border border-gray-200 dark:border-gray-800 px-3 py-1 rounded text-[10px] font-mono text-gray-700 dark:text-gray-300">
//             node: k8s_worker
//           </div>
//         </div>
//       </div>


//         <div className="text-green-600 flex items-center gap-2 text-sm">
//           <span className="material-symbols-outlined text-base">
//             check_circle
//           </span>
//           Automated Correlation
//         </div>
//       </div>
//     </div>

//   </div>
// </div>


//       {/* Key Differentiators */}
// <div id="key-differentiators" className="mb-12 scroll-mt-24">
//   <h3 className="text-xl font-bold text-text-main dark:text-white mb-6">
//     Key Differentiators of Netraa APM
//   </h3>

//   {/* ✅ FIX: padding + overflow visible */}
//   <div className="px-2 md:px-3 overflow-visible">
//     <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
//       {[
//         {
//           title: "Code-level Insight",
//           desc: "No-code instrumentation with deep profiling for Java, Go, Python, and Node.js applications.",
//           icon: "analytics",
//           color: "orange",
//         },
//         {
//           title: "Infra/K8s Visibility",
//           desc: "Native Kubernetes monitoring with cluster-level visibility, node health tracking, and container performance insights.",
//           icon: "analytics",
//           color: "blue",
//         },
//         {
//           title: "Enterprise Security",
//           desc: "RBAC, SSO integration, and data masking out of the box to meet compliance standards.",
//           icon: "analytics",
//           color: "green",
//         },
//       ].map((item, idx) => {
//         const colorStyles = {
//           orange: {
//             bg: "bg-orange-100 dark:bg-orange-900/30",
//             text: "text-orange-500",
//             glow: "bg-orange-400/10 dark:bg-orange-500/10",
//             border: "group-hover:border-orange-300/50 dark:group-hover:border-orange-500/40",
//           },
//           blue: {
//             bg: "bg-blue-100 dark:bg-blue-900/30",
//             text: "text-blue-500",
//             glow: "bg-blue-400/10 dark:bg-blue-500/10",
//             border: "group-hover:border-blue-300/50 dark:group-hover:border-blue-500/40",
//           },
//           green: {
//             bg: "bg-green-100 dark:bg-green-900/30",
//             text: "text-green-500",
//             glow: "bg-green-400/10 dark:bg-green-500/10",
//             border: "group-hover:border-green-300/50 dark:group-hover:border-green-500/40",
//           },
//         };

//         const styles = colorStyles[item.color];

//         return (
//           <div
//             key={idx}
//             className="
//               group relative flex flex-col gap-4 p-6 rounded-xl
//               bg-surface-light dark:bg-[#1A1C20]
//               border border-border-color dark:border-border-dark
//               shadow-sm

//               transition-all duration-300 ease-out
//               hover:-translate-y-1 hover:scale-[1.02]
//               hover:shadow-xl dark:hover:shadow-black/40
//             "
//           >
//             {/* Glow Effect */}
//             <div
//               className={`
//                 absolute inset-0 rounded-xl opacity-0 group-hover:opacity-100
//                 transition duration-300 blur-xl ${styles.glow}
//               `}
//             />

//             {/* Icon */}
//             <div
//               className={`
//                 relative z-10 w-12 h-12 shrink-0 rounded-xl
//                 flex items-center justify-center
//                 ${styles.bg}

//                 transition-all duration-300
//                 group-hover:scale-110 group-hover:rotate-3
//               `}
//             >
//               <span
//                 className={`
//                   material-symbols-outlined text-2xl
//                   ${styles.text}
//                 `}
//               >
//                 {item.icon}
//               </span>
//             </div>

//             {/* Content */}
//             <div className="relative z-10">
//               <h4 className="font-bold text-lg mb-2 text-text-main dark:text-white">
//                 {item.title}
//               </h4>
//               <p className="text-sm text-text-muted leading-relaxed">
//                 {item.desc}
//               </p>
//             </div>

//             {/* Border Glow */}
//             <div
//               className={`
//                 pointer-events-none absolute inset-0 rounded-xl
//                 border border-transparent
//                 transition duration-300
//                 ${styles.border}
//               `}
//             />
//           </div>
//         );
//       })}
//     </div>
//   </div>
// </div>

//       {/* Workflow Integration */}
//       <div id="workflow-integration" className="mb-16 scroll-mt-24">
//         <h3 className="text-xl font-bold text-text-main dark:text-white mb-4">Where Netraa APM Fits in DevOps and SRE Workflows</h3>
//         <p className="text-base text-text-muted dark:text-gray-400 max-w-4xl leading-relaxed mb-6">
//           Netraa APM integrates into DevOps and SRE workflows by enabling real-time deployment validation, SLO monitoring, incident investigation through distributed traces, and performance regression analysis after releases.
//           </p>
//           <div className="p-6 bg-gray-50 dark:bg-[#181818] rounded-xl border border-gray-200 dark:border-gray-800">
//           <div className="flex flex-col lg:flex-row items-center justify-between gap-4">
//             <div className="flex items-center gap-3">
//               <div className="px-3 py-1.5 rounded bg-white dark:bg-gray-800 border border-gray-200 dark:border-gray-700 text-xs font-mono">CI/CD Pipeline</div>
//               <span className="material-symbols-outlined text-gray-400"><MdKeyboardArrowRight/></span>
//               <div className="px-3 py-1.5 rounded bg-white dark:bg-gray-800 border border-gray-200 dark:border-gray-700 text-xs font-mono">Netraa APM Analysis</div>
//               <span className="material-symbols-outlined text-gray-400"><MdKeyboardArrowRight/></span>
//               <div className="px-3 py-1.5 rounded bg-white dark:bg-gray-800 border border-gray-200 dark:border-gray-700 text-xs font-mono">Alerting</div>
//             </div>
//           </div>
//         </div>
//       </div>

//       {/* Target Users */}
// <div id="who-should-use" className="mb-20 scroll-mt-24">
//   <h2 className="text-2xl font-semibold text-gray-900 dark:text-white mb-10">
//     Who Should Use Netraa APM?
//   </h2>

//   <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
//     {[
//       {
//         title: "SRE Teams",
//         icon: "engineering",
//         desc: "Monitor SLOs, track error budgets, and perform fast root cause analysis using correlated telemetry data.",
//         color: "purple",
//       },
//       {
//         title: "DevOps Engineers",
//         icon: "terminal",
//         desc: "Automate CI/CD performance gates and monitor production deployments in real time.",
//         color: "blue",
//       },
//       {
//         title: "Application Architects",
//         icon: "architecture",
//         desc: "Visualize microservice topology and identify structural bottlenecks in distributed systems.",
//         color: "orange",
//       },
//       {
//         title: "Infrastructure & Ops Teams",
//         icon: "storage",
//         desc: "Map application performance to VM, container, and cloud resource constraints.",
//         color: "green",
//       },
//     ].map((user, idx) => {
//       const colorMap = {
//         purple: "text-purple-600 dark:text-purple-400",
//         blue: "text-blue-600 dark:text-blue-400",
//         orange: "text-orange-600 dark:text-orange-400",
//         green: "text-green-600 dark:text-green-400",
//       };

//       return (
//         <div
//           key={idx}
//           className="group rounded-xl border border-gray-200 dark:border-white/10
//                      bg-white dark:bg-[#0F1115]
//                      p-6 transition-all duration-200
//                      hover:-translate-y-1 hover:border-gray-300 dark:hover:border-white/20
//                      hover:shadow-md dark:hover:shadow-black/30"
//         >
//           {/* Icon */}
//           <div className="flex items-center gap-3 mb-4">
//             <span
//               className={`material-symbols-outlined text-xl ${colorMap[user.color]}`}
//             >
//               {user.icon}
//             </span>

//             <h4 className="text-lg font-semibold text-gray-900 dark:text-white">
//               {user.title}
//             </h4>
//           </div>

//           {/* Description */}
//           <p className="text-sm leading-relaxed text-gray-600 dark:text-gray-400">
//             {user.desc}
//           </p>
//         </div>
//       );
//     })}
//   </div>
// </div>
//     </section>
//   </div>
// );